import { useEffect } from 'react';
import Lenis from 'lenis';
import { setLenis } from '../utils/lenis';

if (typeof window !== 'undefined' && 'scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

export default function SmoothScroll({ children }) {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.4,
            easing: (t) => 1 - Math.pow(2, -10 * t),
            orientation: 'vertical',
            gestureOrientation: 'vertical',
            smoothWheel: true,
            wheelMultiplier: 0.9,
            touchMultiplier: 1.2,
            syncTouch: false,
            syncTouchLerp: 0.08,
            lerp: 0.12,
            autoResize: true,
            infinite: false,
            prevent: (node) => node.closest('[data-lenis-prevent]') !== null,
        });

        setLenis(lenis);

        // Scroll-aware class — suppresses expensive hover effects during active scroll
        let scrollTimeout;
        const onScroll = () => {
            document.body.classList.add('is-scrolling');
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
                document.body.classList.remove('is-scrolling');
            }, 150);
        };
        lenis.on('scroll', onScroll);

        let rafId;
        function raf(time) {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        }
        rafId = requestAnimationFrame(raf);

        return () => {
            cancelAnimationFrame(rafId);
            clearTimeout(scrollTimeout);
            document.body.classList.remove('is-scrolling');
            lenis.off('scroll', onScroll);
            lenis.destroy();
            setLenis(null);
        };
    }, []);

    return children;
}
